import React, { useEffect } from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useResponsive from '../../hooks/useResponsive';
import { useLocation } from 'react-router-dom';
import Header from '../../layout/dashboard/header';
import { apiGetEmploymentById } from '../../api/employment';
import { useMutation } from '@tanstack/react-query';
import { useAuth } from '../../hooks/useAuth';
import { getUrlPathId } from '../../utils/url-id';
import { useNotificationService } from '../../components/notification';
import RoleManagementContents from '../../components/profile/RoleManagementContents';
import BackButton from '../../components/UIElements/BackButton';

const RoleManagement = () => {
  const theme = useTheme();
  const location = useLocation();
  const isMedium = useResponsive('down', 'md', 'xl');
  const isSmall = useResponsive('down', 'sm', 'xl');
  const { showNotification } = useNotificationService();
  const { token } = useAuth();

  useEffect(() => {
    const employmentId = getUrlPathId(location?.pathname);
    const fields = { employmentId, token };
    // mutation.mutate(fields);
  }, []);

  const mutation = useMutation({
    mutationFn: (fields: { token: string; employmentId: string }) =>
      apiGetEmploymentById(fields),
    onSuccess: (data) => {
      if (data?.status === 'error') {
        if ('msg' in data) {
          showNotification(data?.msg ?? '', 'error');
          return;
        }
        return;
      }
      if ('data' in data) {
      }
    },
    onError: (error) => {
      showNotification('Fetch process failed', 'error');
    },
  });
  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginRight: '1rem',
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={'row'} alignItems={'center'}>
            <BackButton />
            <Typography
              variant={'subtitle1'}
              sx={{
                fontWeight: 500,
                fontFamily: 'Lexend',
                color: '#2F66F4',
              }}
            >
              RoleManagement
            </Typography>
          </Stack>
        </Box>
      </Header>
      <RoleManagementContents />
    </>
  );
};

export default RoleManagement;
